import type { ApolloClient } from 'apollo-client';
import { clientCreator } from './config/index.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let apolloClient: ApolloClient<Record<any, any>>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getApolloClient = (): ApolloClient<Record<any, any>> => {
	if (!apolloClient) {
		apolloClient = clientCreator();
	}
	return apolloClient;
};
